import React from 'react';
import type { GenericSectionContent } from './types';
import HeroBannerRendering from './renderings/hero-banner';
import OrionRendering from './renderings/orion';
import LyraRendering from './renderings/lyra';
import VegaRendering from './renderings/vega';
import AtlasRendering from './renderings/atlas';
import CygnusRendering from './renderings/cygnus';
import NovaRendering from './renderings/nova';
import MesaRendering from './renderings/mesa';
import SolisRendering from './renderings/solis';
import FAQsRendering from './renderings/faqs';
import FAQGroupsRendering from './renderings/faq-groups';
import VortexRendering from './renderings/vortex';
import NexusRendering from './renderings/nexus';
import HtmlOnlyRendering from './renderings/html-only';
import ChronosRendering from './renderings/chronos';
import PyxisRendering from './renderings/pyxis';
import DracoRendering from './renderings/draco';

const RenderingRegistry: { [key: string]: React.ElementType } = {
  "Hero Banner": HeroBannerRendering,
  "Orion": OrionRendering,
  "Lyra": LyraRendering,
  "Vega": VegaRendering,
  "Atlas": AtlasRendering,
  "Cygnus": CygnusRendering,
  "Nova": NovaRendering,
  "Mesa": MesaRendering,
  "Solis": SolisRendering,
  "FAQs": FAQsRendering,
  "FAQ Groups": FAQGroupsRendering,
  "Vortex": VortexRendering,
  "Nexus": NexusRendering,
  "Lumen": HtmlOnlyRendering,        // keep — existing entries still resolve
  "HTML Only": HtmlOnlyRendering,    // new — authors pick this going forward
  "Chronos": ChronosRendering,
  "Pyxis": PyxisRendering,
  "Draco": DracoRendering,
};

export default function GenericSection({ content }: { content: GenericSectionContent }) {
  const Rendering = RenderingRegistry[content.rendering_type];
  if (!Rendering) {
    console.error(`GenericSection: unknown rendering_type "${content.rendering_type}"`);
    return null;
  }
  return <Rendering content={content} />;
}
